export const styleFlex = { display: 'flex', justifyContent: 'space-between' };
export const styleFlexColumn = { display: 'flex', flexDirection: "column" as "column" };

